import { Chip } from '@mui/material';
import { amber, blue } from '@mui/material/colors';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import React from 'react';

export const GeoStatusChip = ({
  geoStatus,
  showIcon = false,
  size = 'medium',
}: {
  geoStatus: string;
  showIcon?: boolean;
  size?: 'small' | 'medium';
}) => {
  const label = `${geoStatus?.charAt(0).toUpperCase()}${geoStatus?.slice(1)}`;
  const color = geoStatus === 'departed' ? blue[50] : amber[500];
  const icon =
    geoStatus === 'departed' ? <DirectionsRunIcon /> : <DirectionsWalkIcon />;
  const chipIcon = React.useMemo(
    () => (showIcon ? icon : undefined),
    [showIcon]
  );

  if (!geoStatus) return null;

  return (
    <Chip
      icon={chipIcon}
      variant="outlined"
      data-testid="geo-status-chip"
      label={label}
      style={{
        backgroundColor: color,
      }}
      size={size}
    />
  );
};
